// extracted by mini-css-extract-plugin
export default {"results":"PNi7I","title":"TsE2Y","initial":"c320J","empty":"gqbuy","no_results_text":"vgbKO","no_results_desc":"jwnaP","no_results_img":"rf8uo"};